package org.dronda.service.wishlist.core.domain

import kotlin.time.Instant
import kotlin.uuid.Uuid

data class EventAdminDetails(
    val event: WishlistEvent,
    val participants: List<Participant>,
    val maxParticipants: Int,
    val santa: SantaAdminStatus?,
)

data class Participant(
    val user: WishlistUser,
    val isAdmin: Boolean,
    val isAssigned: Boolean,
    val lastEmailedAt: Instant?,
)

data class SantaAdminStatus(
    val isDrawn: Boolean,
    val sendsUsed: Int,
    val maxSends: Int,
    val unassignedCount: Int,
    val allowedSendKinds: List<SantaSendKind>,
    val exclusionsChanged: Boolean,
    val exclusions: List<Exclusion>,
)

data class Exclusion(
    val userA: Uuid,
    val userB: Uuid,
    val direction: SantaExclusionDirection,
)

enum class SantaExclusionDirection {
    BOTH,
    A_TO_B,
    B_TO_A;

    fun reversed(): SantaExclusionDirection = when (this) {
        BOTH -> BOTH
        A_TO_B -> B_TO_A
        B_TO_A -> A_TO_B
    }

    /**
     * The giver → receiver draws this exclusion forbids between [a] and [b].
     */
    fun <T> blockedDraws(a: T, b: T): List<Pair<T, T>> = when (this) {
        BOTH -> listOf(a to b, b to a)
        A_TO_B -> listOf(a to b)
        B_TO_A -> listOf(b to a)
    }
}

enum class SantaSendKind {
    INITIAL,
    SPLICE,
    RESHUFFLE,
}

data class SantaSendResult(
    val emailsSent: Int,
    val emailsFailed: Int,
    val sendsRemaining: Int,
)
